module.exports = __webpack_public_path__ + "static/media/21.90a94885.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding_engage/21.jpg
// module id = 228
// module chunks = 0